import type {
  AnalyticsEventMap,
  AnalyticsEventName,
  AnalyticsProvider,
  AnalyticsUser,
} from './types'
import { posthog } from 'posthog-js'

export class PostHogAnalyticsProvider implements AnalyticsProvider {
  identify(user: AnalyticsUser) {
    posthog.identify(user.id, {
      email: user.email,
      name: user.name,
      ...user.properties,
    })
  }

  reset(resetDeviceId?: boolean) {
    posthog.reset(resetDeviceId)
  }

  track<EventName extends AnalyticsEventName>(
    event: EventName,
    properties: AnalyticsEventMap[EventName],
  ) {
    posthog.capture(event, properties)
  }
}
